import { registerLocaleData } from '@angular/common';
import localeJa from '@angular/common/locales/ja';
import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { PivotSpinnerService } from '@core/services/common';
import { ResourcePolicyService } from '@core/services/apis';
import { MultipleSpinnerService } from '@core/services/common/multiple-spinner.service';

@Component({
  selector: 'pivot-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent {
  constructor(
    private pivotSpinnerService: PivotSpinnerService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private resourcePolicyService: ResourcePolicyService
  ) {

    this.resourcePolicyService.checkResourcePolicy().subscribe();
    this.pivotSpinnerService.trackRouteLoadIndicator();

    // CUSTOM_ICON
    this.matIconRegistry.addSvgIconResolver(
      (name, namespace) => {
        const iconPath = './assets/icons' + (namespace ? '/' + namespace : '') + '/' + name + '.svg';
        return this.domSanitizer.bypassSecurityTrustResourceUrl(iconPath);
      },
    );

    registerLocaleData(localeJa, 'ja-JP');
  }
}
